module.exports = __webpack_public_path__ + "img/timer.158e1c0a.svg";